import { Box, SxProps, Theme } from '@rhg/libs/material';
import { sxAppend } from '@rhg/libs/material/sx';
import { StaticImageData } from '@rhg/libs/next/image';
import { resolveImageSrc } from '@rhg/utils/images/resolveImageSrc';
import { AriaRole, forwardRef } from 'react';
import { BANNER_HEIGHT, BANNER_MAX_HEIGHT, BANNER_WIDTH } from './types';

const styleContainer = {
    width: BANNER_WIDTH,
    minHeight: BANNER_HEIGHT,
    display: 'flex',
    height: '100%',
};

const styleBannerImageContainer = {
    width: '100%',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
};

// Scales image to 3/2 aspect ratio
const styleBannerImage = {
    position: 'relative',
    width: '100%',
    height: '100%',
    aspectRatio: '3 / 2',
    maxHeight: BANNER_MAX_HEIGHT,
    backgroundSize: 'cover',
    backgroundPositionX: 'center',
    backgroundPositionY: 'center',
};

interface ProgramBannerProps {
    heroImageSrc?: string | StaticImageData;
    sx?: SxProps<Theme>;
    sxBannerImage?: SxProps<Theme>;
    sxBannerImageContainer?: SxProps<Theme>;
    role?: AriaRole;
}
export const HeroBannerImage = forwardRef(function BannerImageNoRef(
    {
        heroImageSrc,
        sx,
        sxBannerImage,
        sxBannerImageContainer,
    }: ProgramBannerProps,
    ref
) {
    return (
        <Box ref={ref} sx={sxAppend(styleContainer, sx)}>
            <Box
                sx={sxAppend(styleBannerImageContainer, sxBannerImageContainer)}
            >
                <Box
                    sx={sxAppend(
                        styleBannerImage,
                        sxBannerImage,
                        heroImageSrc && {
                            backgroundImage: `url(${resolveImageSrc(
                                heroImageSrc
                            )})`,
                        }
                    )}
                    data-testid="hero-banner-image"
                />
            </Box>
        </Box>
    );
});
